import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook as fabFaFacebook,
  faDiscord as fabFaDiscord,
  faSteam as fabFaSteam,
  faYoutube as fabFaYoutube,
  faInstagram as fabFaInstagram,
} from '@fortawesome/free-brands-svg-icons';

import 'Components/Utility/SocialPages/SocialPages.scss';

export default function SocialPages({ lightTheme, offWhiteTheme }) {
  return (
    <div
      className={
        classNames(
          'social-pages', { 'sp-light-theme': lightTheme }, { 'off-white-theme': offWhiteTheme },
        )
      }
    >
      <p className="social-title">
        <FormattedMessage id="social-pages.join-community" defaultMessage="Join our community of gamers" />
      </p>
      <p className="social-subtitle">
        <FormattedMessage id="social-pages.million-strong" defaultMessage="2.6 million strong and growing" />
      </p>
      <div className="icon-container">
        <div className="social-icon icon-facebook">
          <a href="https://www.facebook.com/wearefanatical" target="_blank" rel="noopener noreferrer nofollow" aria-label="Facebook">
            <FontAwesomeIcon icon={fabFaFacebook} title="Facebook" />
          </a>
        </div>
        <div className="social-icon icon-x">
          <a href="https://twitter.com/fanatical" target="_blank" rel="noopener noreferrer nofollow" aria-label="X">
            <img
              src="https://cdn.fanatical.com/production/brand/social/twitter-x-white.svg"
              alt="X"
              style={{
                height: '18px',
                width: '18px',
              }}
            />
          </a>
        </div>
        <div className="social-icon icon-steam">
          <a href="https://steamcommunity.com/groups/wearefanatical" target="_blank" rel="noopener noreferrer nofollow" aria-label="Steam">
            <FontAwesomeIcon icon={fabFaSteam} title="Steam" />
          </a>
        </div>
        <div className="social-icon icon-youtube">
          <a href="https://www.youtube.com/wearefanatical" target="_blank" rel="noopener noreferrer nofollow" aria-label="YouTube">
            <FontAwesomeIcon icon={fabFaYoutube} title="YouTube" />
          </a>
        </div>
        <div className="social-icon icon-discord">
          <a href="https://fant.cl/Discord" target="_blank" rel="noopener noreferrer nofollow" aria-label="Discord">
            <FontAwesomeIcon icon={fabFaDiscord} title="Discord" />
          </a>
        </div>
        <div className="social-icon icon-instagram">
          <a href="https://www.instagram.com/wearefanatical" target="_blank" rel="noopener noreferrer nofollow" aria-label="Instagram">
            <FontAwesomeIcon icon={fabFaInstagram} title="Instagram" />
          </a>
        </div>
      </div>
    </div>
  );
}

SocialPages.propTypes = {
  lightTheme: PropTypes.bool,
  offWhiteTheme: PropTypes.bool,
};

SocialPages.defaultProps = {
  lightTheme: false,
  offWhiteTheme: false,
};
